"use strict";
export function switchChainWithCleanup({
  chainId,
  onEnd,
  onStart,
  switchChain
}) {
  return new Promise((resolve, reject) => {
    let didEnd = false;
    const finish = (error) => {
      if (!didEnd) {
        didEnd = true;
        onEnd();
      }
      if (error) {
        reject(error);
      } else {
        resolve();
      }
    };
    onStart();
    if (!switchChain) {
      finish(new Error("Switch chain is unavailable for the active wallet."));
      return;
    }
    try {
      switchChain(
        { chainId },
        {
          onSettled(_, error) {
            finish(error ?? void 0);
          }
        }
      );
    } catch (error) {
      finish(error);
    }
  });
}
